import { Classroom } from '@/api/classroom'

const state = () => ({
    quizzes: [],
    quiz: null,
    savedIdClassroomQuiz: 0,
    questions: [],
    question: null,
    savedIdQuiz: 0,
    LoadingQuiz: false,
    isSuccessQuiz: true,
    messageQuiz: '',
})

const getters = {
    quizList: state => state.quizzes,
    quiz: state => state.quiz,
    questionList: state => state.questions,
    question: state => state.question,
    isLoadingQuiz: state => state.isLoadingQuiz,
    isSuccessQuiz: state => state.isSuccessQuiz,
    messageQuiz: state => state.messageQuiz,
    savedIdClassroomQuiz: state => state.savedIdClassroomQuiz,
    savedIdQuiz: state => state.savedIdQuiz
}

const actions = {
    async fetchAllQuizzes({ commit }, id) {

        commit('setQuizIsLoading', true)
        commit('setSavedIdClassroomQuiz', id)
        await Classroom.quizList(id)
            .then(response => {
                commit('setQuizzes', response.data.data)
                commit('setQuizIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setQuizIsLoading', false)
            })
    },
    async fetchDetailQuiz({ commit }, id) {
        commit('setQuizIsLoading', true)
        await Classroom.quizDetail(id)
            .then(response => {
                // console.log(response)
                commit('setQuizDetail', response.data.data)
                commit('setQuizIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setQuizIsLoading', false)
            })
    },
    async updateQuiz({ commit }, quiz) {
        const id = quiz.id
        const payload = quiz.payload

        await Classroom.quizEdit(id, payload)
            .then(response => {
                if (response.data.success) {
                    commit('setSuccessQuiz', true)
                    commit('setMessageQuiz', 'Berhasil Mengubah Quiz')
                } else {
                    commit('setSuccessQuiz', false)
                    commit('setMessageQuiz', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessQuiz', false)
                commit('setMessageQuiz', error.errors[0].message)
            })
    },
    async addQuiz({ commit }, payload) {
        // console.log('payload vuex', payload)
        await Classroom.quizAdd(payload)
            .then(res => {
                // console.log('dari vuex', res.data)
                if (res.data.success) {

                    commit('setSuccessQuiz', true)
                    commit('setMessageQuiz', 'Berhasil Menambahkan Quiz')
                } else {
                    commit('setSuccessQuiz', false)
                    commit('setMessageQuiz', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessQuiz', false)
                commit('setMessageQuiz', error.errors[0].message)
            })
    },
    async deleteQuiz({ commit }, id) {
        // console.log(id)
        await Classroom.quizDelete(id)
            .then(res => {

                if (res.data.success) {
                    commit('setSuccessQuiz', true)
                    commit('setMessageQuiz', 'Berhasil Menghapus Quiz')
                } else {
                    commit('setSuccessQuiz', false)
                    commit('setMessageQuiz', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessQuiz', true)
                commit('setMessageQuiz', error.errors[0].message)
            })
    },
    async fetchAllQuestions({ commit }, id) {

        commit('setQuizIsLoading', true)
        commit('setSavedIdQuiz', id)
        await Classroom.quizQuestionList(id)
            .then(response => {
                commit('setQuestions', response.data.data)
                commit('setQuizIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setQuizIsLoading', false)
            })
    },
    // async fetchDetailQuestion({ commit }, id) {
    //     commit('setQuizIsLoading', true)
    //     await Classroom.questionDetail(id)
    //         .then(response => {
    //             console.log(response)
    //             commit('setQuestionDetail', response.data.data)
    //             commit('setQuizIsLoading', false)
    //         })
    //         .catch(error => {
    //             console.log(error)
    //             commit('setQuizIsLoading', false)
    //         })
    // },
    async updateQuestion({ commit }, question) {
        const id = question.id
        const payload = question.payload

        await Classroom.quizQuestionEdit(id, payload)
            .then(response => {
                if (response.data.success) {
                    commit('setSuccessQuiz', true)
                    commit('setMessageQuiz', 'Berhasil Mengubah Question')
                } else {
                    commit('setSuccessQuiz', false)
                    commit('setMessageQuiz', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessQuiz', false)
                commit('setMessageQuiz', error.errors[0].message)
            })
    },
    async addQuestion({ commit }, payload) {
        await Classroom.quizQuestionAdd(payload)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccessQuiz', true)
                    commit('setMessageQuiz', 'Berhasil Menambahkan Question')
                } else {
                    commit('setSuccessQuiz', false)
                    commit('setMessageQuiz', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessQuiz', false)
                commit('setMessageQuiz', error.errors[0].message)
            })
    },
    async deleteQuestion({ commit }, id) {
        // console.log(id)
        await Classroom.quizQuestionDelete(id)
            .then(res => {

                if (res.data.success) {
                    commit('setSuccessQuiz', true)
                    commit('setMessageQuiz', 'Berhasil Menghapus Question')
                } else {
                    commit('setSuccessQuiz', false)
                    commit('setMessageQuiz', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessQuiz', true)
                commit('setMessageQuiz', error.errors[0].message)
            })
    }
}

const mutations = {
    setQuizzes: (state, quizzes) => {
        state.quizzes = quizzes
    },
    setQuestions: (state, questions) => {
        state.questions = questions
    },

    setQuizDetail: (state, quiz) => {
        state.quiz = quiz
    },

    setQuizIsLoading: (state, isLoadingQuiz) => {
        state.isLoadingQuiz = isLoadingQuiz
    },

    setSuccessQuiz: (state, isSuccessQuiz) => {
        state.isSuccessQuiz = isSuccessQuiz
    },

    setMessageQuiz: (state, messageQuiz) => {
        state.messageQuiz = messageQuiz
    },
    setSavedIdClassroomQuiz: (state, savedIdClassroomQuiz) => {
        state.savedIdClassroomQuiz = savedIdClassroomQuiz
    },
    setSavedIdQuiz: (state, savedIdQuiz) => {
        state.savedIdQuiz = savedIdQuiz
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}